export interface ParsedRow {
  index: number;
  title: string;
  subtitle?: string;
  originalTitle?: string;
  authorName: string;
  authorWhatsapp?: string;
  publisherName: string;
  category: string;
  publicationYear: string;
  edition: string;
  editionType?: string;
  editionNotes?: string;
  pages: string;
  language: string;
  isbnOriginal?: string;
  synopsis?: string;
  tableOfContents?: string;
  coverUrl?: string;
  purchaseUrl?: string;
  errors: string[];
  isValid: boolean;
}

// Strip BOM or raw UTF-8 BOM representation artifacts (e.g. ï»¿)
export const stripBom = (str: string): string => {
  if (!str) return '';
  return str.replace(/^\uFEFF/, '').replace(/^ï»¿/, '');
};

// Detect delimiter (, or ;)
export const detectDelimiter = (line: string): string => {
  const clean = stripBom(line);
  const commas = (clean.match(/,/g) || []).length;
  const semicolons = (clean.match(/;/g) || []).length;
  return semicolons > commas ? ';' : ',';
};

// Robust CSV line splitter that respects quoted strings with commas and escaped quotes
export const parseCsvLine = (line: string, delimiter: string = ','): string[] => {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;
  const cleanLine = stripBom(line);

  for (let i = 0; i < cleanLine.length; i++) {
    const char = cleanLine[i];
    if (char === '"') {
      if (inQuotes && cleanLine[i + 1] === '"') {
        current += '"';
        i++; // Skip next quote
      } else {
        inQuotes = !inQuotes;
      }
    } else if (char === delimiter && !inQuotes) {
      result.push(current.trim());
      current = '';
    } else {
      current += char;
    }
  }
  result.push(current.trim());
  return result;
};

export const downloadCsvTemplate = () => {
  const headers = [
    'Judul Buku',
    'Subjudul',
    'Judul Asli',
    'Penulis',
    'WhatsApp Penulis',
    'Penerbit',
    'Kategori',
    'Tahun Terbit',
    'Edisi',
    'Tipe Edisi',
    'Catatan Edisi',
    'Halaman',
    'Bahasa',
    'ISBN Orisinal',
    'Sinopsis',
    'Daftar Isi',
    'URL Sampul',
    'Tautan Pembelian',
  ].join(',');

  const examples = [
    [
      '"Laskar Pelangi"',
      '"Kisah Anak Belitong"',
      '""',
      '"Andrea Hirata"',
      '"081234567890"',
      '"Bentang Pustaka"',
      '"Fiksi & Sastra"',
      '2005',
      '"1"',
      '"orisinal"',
      '"Cetakan Pertama"',
      '529',
      '"Indonesia"',
      '"979-3062-79-7"',
      '"Novel inspiratif perjuangan 10 anak Belitung meraih mimpi."',
      '"Bab 1: Sepuluh Murid Baru; Bab 2: Antara Menara"',
      '"https://images.unsplash.com/photo-1544716278-ca5e3f4abd8c?w=600&auto=format&fit=crop&q=80"',
      '"https://www.gramedia.com"',
    ].join(','),
    [
      '"Bumi Manusia"',
      '"Tetralogi Buru 1"',
      '""',
      '"Pramoedya Ananta Toer"',
      '""',
      '"Lentera Dipantara"',
      '"Sejarah & Budaya"',
      '1980',
      '"10"',
      '"cetakan_baru"',
      '"Edisi Khusus"',
      '535',
      '"Indonesia"',
      '"979-97312-3-2"',
      '"Kisah perjuangan dan cinta Minke di masa kolonial Hindia Belanda."',
      '""',
      '""',
      '""',
    ].join(','),
    [
      '"Saman"',
      '""',
      '"Saman"',
      '"Ayu Utami"',
      '""',
      '"Kepustakaan Populer Gramedia"',
      '"Fiksi & Sastra"',
      '1998',
      '"1"',
      '"orisinal"',
      '""',
      '192',
      '"Indonesia"',
      '"979-9023-14-9"',
      '"Novel sastra pemenang sayembara DKJ 1998."',
      '""',
      '""',
      '""',
    ].join(','),
  ].join('\r\n');

  // Clean UTF-8 CSV without BOM characters to avoid ï»¿ artifacts
  const csvContent = headers + '\r\n' + examples;
  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', 'uibn_template_impor_massal.csv');
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

